import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getDevices(locationId: number): angular.IPromise<CASLink.Device.Ui.ViewModel.Dashboard.DashboardViewModel> {
        return this.proxyService.request({
                endPoint: DashboardService.getEndpointName(),
                route: 'getDevices',
                routeParams: {
                    locationId: locationId
                }
            }
        ).as<CASLink.Device.Ui.ViewModel.Dashboard.DashboardViewModel>();
    }

    private static getEndpointName() {
        return 'dashboard';
    }
}
